/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import * as api from '../api';

export const verifyAddress = makeAsyncAction(
    types.VERIFY_ADDRESS,
    (address) => () => api.verifyAddress(address)
);
